import { useEffect } from 'react'
import LightbulbIcon from '../Svg/LightbulbIcon'
import { LightTheme, DarkTheme } from '../../Constants/Configuration'
import { setActiveTheme } from '../../Slices/ConfigurationSlice'
import { useAppDispatch, useAppSelector } from '../../hooks'

function ThemeButton() {
  const dispatch = useAppDispatch()
  const activeTheme = useAppSelector(state => state.present.configuration.activeTheme)
  const serverConfig = useAppSelector(state => state.present.article.serverConfig)
  const userValue = useAppSelector(state => state.present.configuration.userValue)

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0]
    body.setAttribute('data-theme', activeTheme)
  }, [activeTheme])

  return (
    <div
      className='theme-btn'
      onClick={() => {
        const theme = activeTheme === LightTheme ? DarkTheme : LightTheme
        dispatch(setActiveTheme({ theme: theme, user: userValue, serverConfig: serverConfig }))
      }}
    >
      <LightbulbIcon
        className={'icon-lightbulb'}
        fill={activeTheme === LightTheme ? 'var(--icon-light-dark-second-color)' : 'var(--icon-light-dark-first-color)'}
        stroke={
          activeTheme === LightTheme ? 'var(--icon-light-dark-first-color)' : 'var(--icon-light-dark-second-color)'
        }
      />
    </div>
  )
}

export default ThemeButton
